function ArchivePersonCard({ person, rosters, selectedRosterId, setSelectedRosterId, onUnarchive }) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "10px",
          textAlign: "left",
          cursor: "pointer",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          marginBottom: "15px",
          width: "100%",
        }}
      >
        <img
          src={person.picture || "https://via.placeholder.com/150"}
          alt={person.name}
          style={{
            width: "50px",
            height: "50px",
            objectFit: "cover",
            borderRadius: "8px",
            marginRight: "15px",
          }}
        />
        <div style={{ flex: 1 }}>
          <h3 style={{ fontSize: "1rem", color: "#333", margin: 0 }}>{person.name}</h3>
          {person.age && (
            <p style={{ fontSize: "0.9rem", color: "#666", margin: "5px 0" }}>
              {person.age} years old
            </p>
          )}
          <select
            value={selectedRosterId}
            onChange={(e) => setSelectedRosterId(e.target.value)}
            style={{ padding: "5px", marginLeft: "10px" }}
          >
            <option value="">Select Roster</option>
            {rosters.map((roster) => (
              <option key={roster.id} value={roster.id}>
                {roster.name}
              </option>
            ))}
          </select>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onUnarchive(person);
          }}
          style={{
            padding: "5px 10px",
            backgroundColor: "green",
            color: "white",
            borderRadius: "5px",
            border: "none",
            cursor: "pointer",
          }}
        >
          Unarchive
        </button>
      </div>
    );
  }
  
  export default ArchivePersonCard;
  